import { defaultMemoize, createSelectorCreator } from 'reselect';
import { is } from 'immutable';

const createImmutableSelector = createSelectorCreator(defaultMemoize, is);

const homesSelector = state => state.environments.fhe.data.Homes.get('list');
const homesArraySelector = createImmutableSelector(homesSelector, homes =>
    homes.reduce((reduction, value, key) => [...reduction, { value: key, label: value.get('label') }], [])
);

export default {
    getHomes: homesSelector,
    getHomesArray: homesArraySelector
};



// WEBPACK FOOTER //
// ./environments/fhe/scenes/PushNotification/selectors.js